if(!customElements.get('td-sticky-atc')) {
    class TdStickyAtc extends HTMLElement {
        constructor() {
            super();
         
            this.target = document.querySelector('.td-product__details__wrapper .td-product__title');
            this.footer = document.querySelector('footer');
        }
        connectedCallback() {
          if (!this.target) {
            console.error('Sticky ATC target element not found.');
            
          } else {         
            this.stickyObserver()
          }
          if (!this.footer) {
            console.error('Footer element not found.');
           
          }else {
              this.footerObserver()
          }
           
        }
        footerObserver() {
            const options = {
                rootMargin: '500px',
                root: null,
                threshold: 1.0
              };
              
              const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                  
                  if(entry.intersectionRect.width > 0) this.toggleVisibility(entry.isIntersecting);
                })
             
              }, options)
              if(this.footer) observer.observe(this.footer);
        }
        stickyObserver() {
            const options = {
                rootMargin: '100px',
                root: null,
                threshold: 1.0
              };
              
              const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                 
                  this.toggleVisibility(entry.isIntersecting);
                })
             
              }, options)
              if(this.target) observer.observe(this.target);
              
        }
        toggleVisibility(isIntersecting) {
          if (isIntersecting) {
              this.classList.remove('show-form');
          } else {
              this.classList.add('show-form');
          }
      }
    }
    customElements.define('td-sticky-atc', TdStickyAtc);
}